import {UserRole} from './user-role.enum';

/**
 * Returns true if at least one of the provided user roles exists
 * in the list of allowed roles.
 * @param allowedRoles The list of allowed roles
 * @param userRoles The list of roles the user has
 */
export const hasRole = (allowedRoles: UserRole[], userRoles: UserRole[]) => allowedRoles.some((r) => userRoles.includes(r));
